import { IconX } from '@tabler/icons-react';
import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import { postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { toast } from 'sonner';

const AddAppModal = ({ buttonComponent, callback, callback2 }) => {
    const [show, setShow] = useState(false);
    const [currentAppType, setCurrentAppType] = useState(1);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const add = async () => {
        loadingShow();
        let postData = {};
        if (currentAppType == 1) {
            postData = {
                "platform": currentAppType,
                "SHA256": document.getElementById('sha256').value.trim(),
                "androidFallbackUrl": document.getElementById('androidFallbackUrl')?.value?.trim(),
                "webFallbackUrl": document.getElementById('webFallbackUrl')?.value?.trim(),
                "appPackage": document.getElementById('appPackage')?.value?.trim()
            }
        }
        else if (currentAppType == 2) {
            postData = {
                "platform": currentAppType,
                "bundleId": document.getElementById('bundleId').value.trim(),
                "iosFallbackUrl": document.getElementById('iosFallbackUrl').value?.trim(),
                "webFallbackUrl": document.getElementById('webFallbackUrl').value.trim(),
                "appPackage": document.getElementById('appPackage')?.value?.trim()
            }
        }
        else if (currentAppType == 3) {
            postData = {
                "platform": currentAppType,
                "webUrl": document.getElementById('webUrl').value?.trim(),
                "webFallbackUrl": document.getElementById('webFallbackUrl').value.trim()
            }
        }
        let resp = await postApi(postData, urlApi.addApp);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            callback?.();
            callback2?.();
            handleClose();
        }
        else {
            toast.error(resp.message);
        }
    }

    const handleAppTypeChange = (e) => {
        setCurrentAppType(parseInt(e.target.value));
    }

    return (
        <>
            <div className='max-w-max' onClick={handleShow}>{buttonComponent}</div>
            <Modal show={show} onHide={handleClose} backdrop="static" size='lg'>
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold mb-0">Add an app.</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />
                    <div className='mb-3'>
                        <label htmlFor="platform" className='text-sm font-semibold mb-1'>App Platform*</label>
                        <select name="" id="platform" className='w-full px-3 py-2 rounded-md border-2 text-sm' onChange={handleAppTypeChange} defaultValue={currentAppType}>
                            <option value="" disabled>App Platform</option>
                            <option value="1">Android</option>
                            <option value="2">IOS</option>
                            <option value="3">WEB</option>
                        </select>
                    </div>
                    {currentAppType == 1 &&
                        <div>
                            <div className='mb-3'>
                                <label htmlFor="sha256" className='text-sm font-semibold mb-1'>Android App signature (SHA256)*</label>
                                <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='sha256' />
                            </div>
                            <div className='mb-3'>
                                <label htmlFor="androidFallbackUrl" className='text-sm font-semibold mb-1'>Android Fallback URL*</label>
                                <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='androidFallbackUrl' />
                            </div>
                        </div>
                    }
                    {currentAppType == 2 &&
                        <div>
                            <div className='mb-3'>
                                <label htmlFor="bundleId" className='text-sm font-semibold mb-1'>IOS app Bundle ID*</label>
                                <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='bundleId' />
                            </div>
                            <div className='mb-3'>
                                <label htmlFor="iosFallbackUrl" className='text-sm font-semibold mb-1'>IOS Fallback URL*</label>
                                <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='iosFallbackUrl' />
                            </div>
                        </div>
                    }
                    {currentAppType == 3 &&
                        <div>
                            <div className='mb-3'>
                                <label htmlFor="webUrl" className='text-sm font-semibold mb-1'>Web URL*</label>
                                <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='webUrl' />
                            </div>
                        </div>
                    }
                    {currentAppType != 3 &&
                        <div className='mb-3'>
                            <label htmlFor="appPackage" className='text-sm font-semibold mb-1'>App Package*</label>
                            <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='appPackage' />
                        </div>
                    }
                    <div className='mb-3'>
                        <label htmlFor="webFallbackUrl" className='text-sm font-semibold mb-1'>Web Fallback URL*</label>
                        <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='webFallbackUrl' />
                    </div>
                    <hr className='my-3' />
                    <div className='flex justify-end gap-3'>
                        <button className='cancel-btn' onClick={handleClose}>Cancel</button>
                        <button className='primary-btn' onClick={() => add()}>Add</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default AddAppModal